// All js
class SectionId {
  static #separator = '__';
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));
    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;
    
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';
    postProcessCallbacks?.forEach((callback) => callback(newNode));
    setTimeout(() => oldNode.remove(), 500);
  }
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

// page scrollbar width
function updateScrollbarWidthOnce() {
  const scrollbar = window.innerWidth - document.documentElement.clientWidth;
  if (scrollbar > 0) {
    document.documentElement.style.setProperty('--scrollbar-width',`${scrollbar}px`);
  }
}
document.addEventListener('DOMContentLoaded', updateScrollbarWidthOnce);
window.addEventListener('resize', updateScrollbarWidthOnce);


// Step 3 js with mouse hover and click js 
class BzDropdown extends HTMLElement {
  constructor() {
    super();
    this._onClickOutside = this._handleOutsideClick.bind(this);
    this._onKeyDown = this._handleKeyDown.bind(this);
  }

  connectedCallback() {
    const settingMode = this.getAttribute('mode') || 'on_click';
    const isDesktop = window.innerWidth >= 992;
    const mode = (settingMode === 'on_hover' && isDesktop) ? 'on_hover' : 'on_click';
    const button = this.querySelector('bz-button');
    const closeButton = this.querySelector('.close-btn');

    // if (button) {
    //   button.setAttribute('tabindex', '0');

    //   button.addEventListener('keydown', (event) => {
    //     if (event.key === 'Enter' || event.key === ' ') {
    //       event.preventDefault();
    //       this.toggle();
    //     }
    //   });

    //   this.addEventListener('focusout', (event) => {
    //     const nextFocused = event.relatedTarget;
    //     if (!this.contains(nextFocused)) {
    //       this.removeAttribute('open');
    //     }
    //   });
    // }

    if (mode === 'on_click') {
      if (button) {
        button.addEventListener('click', () => this.toggle());
      }
      if (!this.hasAttribute('no-outside-close')) {
        document.addEventListener('click', this._onClickOutside);
      }
    }

    this._setupKeyboard(button, mode);

    if (mode === 'on_hover') {
      let closeTimer;
      this.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        this.setAttribute('open', '');
      });
      this.addEventListener('mouseleave', () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          this.removeAttribute('open');
        }, 250);
      });
    }
    document.addEventListener('keydown', this._onKeyDown);

    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        const dropdown = event.target.closest('bz-dropdown');
        if (dropdown) dropdown.removeAttribute('open');
      });
    }
  }

  disconnectedCallback() {
    if (!this.hasAttribute('no-outside-close')) {
      document.removeEventListener('click', this._onClickOutside);
    }
    document.removeEventListener('keydown', this._onKeyDown);
    this._openObserver?.disconnect();
    this._staticMq?.removeEventListener('change', this._syncStatic);
  }

  /* Keyboard access
     - bz-button with a link inside (header menus): the caret <button> is the toggle
     - plain bz-button (filters, sort, footer, cart note, localization): becomes role="button"
     - data-static-from="768": the toggle is removed at that width and up (always-open footer columns) */
  _setupKeyboard(button, mode) {
    if (!button) return;
    const content = button.nextElementSibling;
    const composite = button.querySelector('a[href]');
    this._control = composite ? button.querySelector('button.click_link, button[data-dropdown-toggle]') : button;
    if (!this._control) return;

    if (content) {
      if (!content.id) content.id = `BzDropdown-${Math.random().toString(36).slice(2, 9)}`;
      this._control.setAttribute('aria-controls', content.id);
    }

    if (!composite) {
      this._syncStatic = () => {
        const isStatic = !!this._staticMq?.matches;
        if (isStatic) {
          ['role', 'tabindex', 'aria-expanded', 'aria-controls'].forEach((attr) => button.removeAttribute(attr));
          return;
        }
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        if (content) button.setAttribute('aria-controls', content.id);
        this._syncExpanded();
      };
      const from = parseInt(this.dataset.staticFrom, 10);
      if (from) {
        this._staticMq = matchMedia(`(min-width: ${from}px)`);
        this._staticMq.addEventListener('change', this._syncStatic);
      }
      this._syncStatic();

      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (button.getAttribute('role') !== 'button' || event.target !== button) return;
        event.preventDefault();
        this.toggle();
      });
    } else if (mode === 'on_hover') {
      // Hover menus: the caret button still opens / closes from the keyboard
      this._control.addEventListener('click', (event) => {
        if (event.detail === 0) this.toggle();
      });
    }

    // Keep aria-expanded in sync however [open] is changed
    this._syncExpanded();
    this._openObserver = new MutationObserver(() => this._syncExpanded());
    this._openObserver.observe(this, { attributes: true, attributeFilter: ['open'] });

    // Popover style dropdowns close when focus moves outside them
    if (!this.hasAttribute('no-outside-close') && !this.classList.contains('filters__disclosure') && !this.classList.contains('sorting')) {
      this.addEventListener('focusout', (event) => {
        if (!this.hasAttribute('open') || !event.relatedTarget || this.contains(event.relatedTarget)) return;
        if (content && getComputedStyle(content).position === 'absolute') this.removeAttribute('open');
      });
    }
  }

  _syncExpanded() {
    if (!this._control || this.classList.contains('bz-mega-bound')) return;
    if (this._control === this.querySelector(':scope > bz-button') && !this._control.hasAttribute('role')) return;
    this._control.setAttribute('aria-expanded', this.hasAttribute('open') ? 'true' : 'false');
  }

  toggle(force) {
    const isOpen = this.hasAttribute('open');
    const shouldOpen = typeof force === 'boolean' ? force : !isOpen;
    if (shouldOpen) this.setAttribute('open', '');
    else this.removeAttribute('open');
    this.dispatchEvent(new Event('toggle'));
  }

  _handleOutsideClick(event) {
    if (!this.hasAttribute('open')) return;
    if (this.contains(event.target)) return;
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    if (path.includes(this)) return;
    this.removeAttribute('open');
  }
  
  _handleKeyDown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    if (!this.hasAttribute('open')) return;
    const hadFocus = this.contains(document.activeElement);
    const content = this.querySelector(':scope > bz-button')?.nextElementSibling;
    const isPopover = !content || getComputedStyle(content).position === 'absolute';
    if (!hadFocus && !isPopover) return; // leave open accordions alone
    this.removeAttribute('open');
    if (hadFocus && this._control && window.BzA11y?.isVisible(this._control)) this._control.focus();
  }
}
customElements.define('bz-dropdown', BzDropdown);

// Off-canvas drawer
class WbDrawer extends HTMLElement {
  constructor() {
    super();
    this._outside = (e) => this.#onOutside(e);
    this._escape = (e) => { if (e.key === 'Escape') this.#hide(); };
  }

  connectedCallback() {
    const target = this.getAttribute('target');
    if (!target) return;

    this.drawer = document.querySelector(target);
    if (!this.drawer) return;

    // Dialog semantics for the panel (filter drawer, popup pages, gift wrap)
    if (!this.drawer.hasAttribute('role')) this.drawer.setAttribute('role', 'dialog');
    this.drawer.setAttribute('aria-modal', 'true');
    if (!this.drawer.hasAttribute('aria-label') && !this.drawer.hasAttribute('aria-labelledby')) {
      const heading = this.drawer.querySelector('h1, h2, h3, .mobile-filters_heading');
      if (heading?.textContent.trim()) this.drawer.setAttribute('aria-label', heading.textContent.trim().replace(/\s+/g, ' '));
    }

    // Bind every trigger that points at the same panel
    document
      .querySelectorAll(`wb-drawer[target="${target}"] [drawer-button]`)
      .forEach((btn) => {
        btn.setAttribute('aria-haspopup', 'dialog');
        btn.addEventListener('click', () => this.#show(btn));
      });

    this.drawer.addEventListener('click', (e) => {
      e.stopPropagation();
      if (e.target.closest('.drawer-close, .close_modal')) this.#hide();
    });

    document.addEventListener('click', this._outside);
    document.addEventListener('keydown', this._escape);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._outside);
    document.removeEventListener('keydown', this._escape);
  }

  get #overlayOn() {
    return this.getAttribute('overlay') === 'true';
  }

  #show(opener) {
    if (!this.drawer || this.drawer.classList.contains('drawer_active')) return;
    this.drawer.classList.add('drawer_active');
    if (this.#overlayOn) document.body.classList.add('Vdrawer_open', 'overflow-hidden');
    window.BzA11y?.trapFocus(this.drawer, { returnTo: opener || document.activeElement });
  }

  #hide() {
    if (!this.drawer || !this.drawer.classList.contains('drawer_active')) return;
    this.drawer.classList.remove('drawer_active');
    window.BzA11y?.releaseFocus(this.drawer);
    if (this.#overlayOn && !document.querySelector('.drawer_content.drawer_active')) {
      document.body.classList.remove('Vdrawer_open', 'overflow-hidden');
    }
  }

  #onOutside(event) {
    if (!this.drawer?.classList.contains('drawer_active')) return;
    if (document.body.classList.contains('fullscreen-open')) return;

    if (this.drawer.id) {
      const triggers = document.querySelectorAll(
        `wb-drawer[target="#${this.drawer.id}"] [drawer-button]`
      );
      if ([...triggers].some((btn) => btn.contains(event.target))) return;
    }

    if (!this.drawer.contains(event.target)) this.#hide();
  }
}
customElements.define('wb-drawer', WbDrawer);

// Quantity stepper
class WbQuantity extends HTMLElement {
  connectedCallback() {
    const dec = this.querySelector('[data-qty-minus]');
    const inc = this.querySelector('[data-qty-plus]');
    const field = this.querySelector('.qty-input');
    const wrap = this.querySelector('.quantity-wrap');
    if (!field) return;

    const min = parseInt(field.min, 10) || 1;
    const max = parseInt(field.max, 10) || 9999;
    const step = parseInt(field.step, 10) || 1;
    const clamp = (n) => Math.max(min, Math.min(max, n));
    const read = () => parseInt(field.value, 10) || min;

    // Product form: local only
    if (this.closest('product-form')) {
      const write = (n) => { field.value = clamp(n); };
      dec?.addEventListener('click', () => write(read() - 1));
      inc?.addEventListener('click', () => write(read() + 1));
      field.addEventListener('change', () => write(read()));
      return;
    }

    // Cart sidebar: persist via Cart API
    if (!this.closest('bz-cart-sidebar')) return;
    const key = wrap?.dataset.key;
    if (!key) return;

    const errBox = this.nextElementSibling;
    const errText = errBox?.querySelector('.qty_msg');
    const loader = this.closest(`[data-key="${key}"]`)?.querySelector('[data-atc-loader]');
    let abort = null;
    let timer = 0;

    const paintError = (msg) => {
      if (!errBox || !errText) return;
      errText.textContent = msg || '';
      errBox.hidden = !msg;
    };

    const warnMax = (n) => {
      if (n > max) {
        document.dispatchEvent(new CustomEvent('cart:max-quantity', { detail: { key, max } }));
      }
    };

    const persist = (n) => {
      const quantity = clamp(n);
      abort?.abort();
      abort = new AbortController();
      loader?.classList.remove('hidden');

      const childKey = wrap?.dataset.giftChild;
      const endpoint = childKey ? '/cart/update.js' : '/cart/change.js';
      const payload = childKey
        ? { updates: { [key]: Number(quantity), [childKey]: Number(quantity) } }
        : { id: key, quantity: Number(quantity) };

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: abort.signal,
      })
        .then(async (res) => {
          loader?.classList.add('hidden');
          if (!res.ok) {
            const data = await res.json().catch(() => ({}));
            paintError(data.description || 'Unable to update quantity');
            return;
          }
          const cart = await res.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          field.value = quantity;
          paintError('');
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          console.error(err);
          loader?.classList.add('hidden');
          paintError('Something went wrong. Please try again.');
        });
    };

    // Coalesce rapid clicks into one request
    const queue = (n) => {
      field.value = clamp(n);
      clearTimeout(timer);
      timer = setTimeout(() => persist(read()), 200);
    };

    dec?.addEventListener('click', () => queue(read() - step));
    inc?.addEventListener('click', () => {
      const n = read() + step;
      warnMax(n);
      queue(n);
    });
    field.addEventListener('change', () => {
      const n = read();
      warnMax(n);
      persist(clamp(n));
    });
  }
}
customElements.define('wb-quantity', WbQuantity);


// Video  js    =============
class WbVideo extends HTMLElement {
  connectedCallback() {
    this.videoType = this.dataset.type;
    this.autoplay = this.dataset.autoplay === 'true';
    this.cover = this.querySelector('.video-cover');
    this.video = this.querySelector('video,iframe');
    this.button = this.querySelector('.play_toggle');
    this.iframeBtn = this.querySelector('.ply_iframe');
    this.removeButton = this.querySelector('.rmv_btn');

    if (this.autoplay) this.hideCover();
    else this.showCover();

    if (this.autoplay && this.dataset.toggle === 'true') this.classList.add('is-started');

    this.button?.addEventListener('click', () => {
      this.toggle();
      this.updateButton();
    });
    this.iframeBtn?.addEventListener('click', () => this.playIframe());
    this.removeButton?.addEventListener('click', (event) => {
      event.preventDefault();
      this.rmvButton();
    });
    if (this.button) this.updateButton();

    if (this.videoType === 'by_drop' && this.video) {
      if (this.autoplay) {
        this.video.addEventListener('play', () => this.updateButton(), { once: true });
      }
      this.video.addEventListener('ended', () => {
        if (this.dataset.toggle === 'true') this.classList.remove('is-started');
        this.showCover();
        this.updateButton();
      });
      this.video.addEventListener('pause', () => this.updateButton());
      this.video.addEventListener('play', () => {
        this.hideCover();
        if (this.dataset.toggle === 'true') this.classList.add('is-started');
        this.updateButton();
      });
    }

    if (this.videoType === 'by_link') {
      this.cover?.addEventListener('click', () => this.playIframe());
    }
  }

  toggle() {
    if (this.videoType !== 'by_drop' || !this.video) return;
    if (this.video.paused) this.video.play();
    else this.video.pause();
  }

  playIframe() {
    if (!this.video) return;
    const url = new URL(this.video.src, window.location.href);
    url.searchParams.set('autoplay', '1');
    url.searchParams.set('mute', '1');
    this.video.src = url.toString();
    this.hideCover();
    if (this.dataset.toggle === 'true') this.classList.add('is-started');
    this.updateButton();
  }

  rmvButton() {
    const content = this.querySelector('.bz-vb__content');
    if (content) {
      content.classList.add('is-closed');
      return;
    }
    if (this.removeButton) this.removeButton.style.display = 'none';
  }

  showCover() {
    if (!this.video) return;
    if (this.cover) this.cover.style.display = 'block';
    this.video.style.opacity = '0';
    this.video.style.pointerEvents = 'none';
    if (this.iframeBtn) this.iframeBtn.style.opacity = 1;
  }

  hideCover() {
    if (!this.video) return;
    if (this.cover) this.cover.style.display = 'none';
    this.video.style.opacity = '1';
    this.video.style.pointerEvents = 'auto';
    if (this.iframeBtn) this.iframeBtn.style.opacity = 0;
  }

  updateButton() {
    if (!this.button || !this.video) return;
    const isPlaying =
      this.videoType === 'by_drop' ? !this.video.paused : this.video.src.includes('autoplay=1');
    this.button.classList.toggle('is-playing', isPlaying);
  }
}
customElements.define('wb-video', WbVideo);

// Video pause js [ video final code only modal pending ]
(function () {
  function pauseHTML5(except) {
    document.querySelectorAll('.bz_product_image  video').forEach(v => {
      if (v !== except) v.pause();
    });
  }
  function pauseIframes(except) {
    document.querySelectorAll('.bz_product_image  iframe').forEach((iframe) => {
      if (iframe === except) return;
      iframe.contentWindow?.postMessage(
        JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
        '*'
      );
      iframe.contentWindow?.postMessage({ method: 'pause' }, '*');
      const host = iframe.closest('bz-video');
      if (host) host._bzIframePaused = true;
    });
  }
  function resetAll3DModels(except = null) {
    document.querySelectorAll('bz-product-model').forEach(model => {
      if (model === except) return;
      if (model.hasAttribute('loaded')) {
        const s = window.bzMainSwiperFromGalleryEl?.(model);
        if (s) s.allowTouchMove = true;
      }
      const viewer = model.querySelector('model-viewer');
      if (viewer) {
        if (viewer.dataset.removing === '1') return;
        viewer.dataset.removing = '1';
        viewer.style.transition = viewer.style.transition || 'opacity .4s ease';
        viewer.style.opacity = '0';
        viewer.style.pointerEvents = 'none';
        setTimeout(() => {
          viewer.remove();
          model.removeAttribute('loaded');
        }, 200);
      } else {
        model.removeAttribute('loaded');
      }
    });
  }
  function coordinateProductMedia(except3dModel = null) {
    pauseHTML5(null);
    pauseIframes(null);
    resetAll3DModels(except3dModel);
    document.querySelectorAll('.bz_product_image .media_url').forEach(w => w.classList.remove('is-playing'));
  }
  window.bzCoordinateProductMedia = coordinateProductMedia;
  document.addEventListener('click', function (e) {
    const layer = e.target.closest('.ply_iframe');
    if (!layer) return;
    const wrapper = layer.closest('.bz_product_image .media_url');
    if(wrapper){
      const iframe = wrapper.querySelector('iframe');
      pauseHTML5(null);
      pauseIframes(iframe);
      resetAll3DModels(null);
      document.querySelectorAll('.bz_product_image .media_url').forEach(w => w.classList.remove('is-playing'));
      wrapper.classList.add('is-playing');
      layer.style.pointerEvents = 'none';
      setTimeout(() => { layer.style.pointerEvents = ''; }, 50);
    }
  });
  document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const modelBtn = e.target.closest('.bz_product_image [id^="3d-model-"]');
      if (modelBtn) {
        const host = modelBtn.closest('bz-product-model');
        if (host && host.hasAttribute('loaded')) {
          e.preventDefault();
          const wrap3d = host.closest('.product_3d_model');
          const zone = wrap3d?.closest('.bz_product_image');
          resetAll3DModels(null);
          setTimeout(() => {
            wrap3d?.querySelector('[id^="3d-model-"]')?.focus();
            function onTab(ev) {
              if (ev.key !== 'Tab' || !wrap3d.contains(document.activeElement)) return;
              wrap3d.removeEventListener('keydown', onTab, true);
              ev.preventDefault();
              if (!zone) return;
              const sel ='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
              const mask = ev.shiftKey ? Node.DOCUMENT_POSITION_PRECEDING : Node.DOCUMENT_POSITION_FOLLOWING;
              const els = [...zone.querySelectorAll(sel)].filter((el) => {
                if (wrap3d.contains(el) || !(wrap3d.compareDocumentPosition(el) & mask)) return false;
                const s = getComputedStyle(el);
                return !el.hidden && s.display !== 'none' && s.visibility !== 'hidden' && el.getClientRects().length;
              });
              (ev.shiftKey ? els[els.length - 1] : els[0])?.focus();
            }
            wrap3d.addEventListener('keydown', onTab, true);
          }, 220);
          return;
        }
      }
      const playBtn = e.target.closest('.bz_product_image .ply_iframe button, .bz_product_image .media_url button.play_toggle'
      );
      if (!playBtn) return;
      e.preventDefault();
      playBtn.click();
    },
    true
  );
  document.addEventListener('play', function (e) {
    if (e.target.tagName !== 'VIDEO' || !e.target.closest('.bz_product_image')) return;
    pauseHTML5(e.target);
    pauseIframes(null);
    resetAll3DModels(null);
    document.querySelectorAll('.bz_product_image .media_url').forEach(w => w.classList.remove('is-playing'));
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.bz_product_image')) return;
    const model = e.target.closest('bz-product-model');
    if (model) {
      coordinateProductMedia(model);
      return;
    }
    if (e.target.closest('[data-shopify-xr]')) {
      coordinateProductMedia(null);
    }
  });
})();

// Tab content
// class WbTabView extends HTMLElement {
//   connectedCallback() {
//     this._links = this.querySelectorAll('[data-tab-link]');
//     this._panels = this.querySelectorAll('[data-tab-content]');

//     this._links.forEach((link, index) => {
//       link.setAttribute('tabindex', '0');
//       link.addEventListener('click', () => this.activateTab(index));
//       link.addEventListener('keydown', (e) => {
//         if (e.key === 'Enter' || e.key === ' ') {
//           e.preventDefault();
//           this.activateTab(index);
//         }
//       });
//     });

//     if (this._links.length) this.activateTab(0);
//   }

//   activateTab(index) {
//     this._links.forEach((link, i) => link.classList.toggle('active', i === index));
//     this._panels.forEach((panel, i) => panel.classList.toggle('active', i === index));
//   }
// }
// customElements.define('wb-tab-view', WbTabView);
class WbTabView extends HTMLElement {
  connectedCallback() {
    this._links = [...this.querySelectorAll('[data-tab-link]')];
    this._panels = this.querySelectorAll('[data-tab-content]');
    this._media = this.querySelectorAll('[data-tab-media]');
    // Tabs pattern: one tab stop for the list, arrows move between tabs
    const uid = `BzTabs-${Math.random().toString(36).slice(2, 8)}`;
    const list = this._links[0]?.parentElement;
    if (list && this._links.every((link) => link.parentElement === list)) list.setAttribute('role', 'tablist');
    this._links.forEach((link, i) => {
      link.setAttribute('role', 'tab');
      if (!link.id) link.id = `${uid}-tab-${i}`;
      const panel = this._panels[i];
      if (panel) {
        if (!panel.id) panel.id = `${uid}-panel-${i}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', link.id);
        // A panel with no links / buttons (e.g. a nutrition table) takes focus itself
        const hasControl = panel.querySelector('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!hasControl && !panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '0');
        link.setAttribute('aria-controls', panel.id);
      }
    });
    this._onPointer = (e) => {
      const link = e.target.closest?.('[data-tab-link]');
      if (!link || !this.contains(link)) return;
      if (e.type === 'mousedown') {
        if (link.closest('.bz-inside__tabs')) e.preventDefault();
        return;
      }
      let index = this._links.indexOf(link);
      if (index < 0) return;
      if (e.type === 'keydown') {
        const last = this._links.length - 1;
        const moves = { ArrowRight: index + 1, ArrowDown: index + 1, ArrowLeft: index - 1, ArrowUp: index - 1, Home: 0, End: last };
        if (e.key in moves) {
          if (e.target !== link) return;
          index = moves[e.key] > last ? 0 : moves[e.key] < 0 ? last : moves[e.key];
          e.preventDefault();
          this.activateTab(index);
          this._links[index].focus();
          return;
        }
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
      }
      this.activateTab(index);
    };
    this.addEventListener('mousedown', this._onPointer);
    this.addEventListener('click', this._onPointer);
    this.addEventListener('keydown', this._onPointer);
    this._onBlockSelect = (e) => this._onPointer(e);
    document.addEventListener('shopify:block:select', this._onBlockSelect);
    if (this._links.length) this.activateTab(0);
  }

  disconnectedCallback() {
    this.removeEventListener('mousedown', this._onPointer);
    this.removeEventListener('click', this._onPointer);
    this.removeEventListener('keydown', this._onPointer);
    document.removeEventListener('shopify:block:select', this._onBlockSelect);
    clearTimeout(this._scrollTimer);
  }

  activateTab(index) {
    const active = (nodes) => nodes.forEach((node, i) => node.classList.toggle('active', i === index));
    this._links.forEach((link, i) => {
      link.setAttribute('aria-selected', i === index ? 'true' : 'false');
      link.tabIndex = i === index ? 0 : -1;
    });
    active(this._links);
    active(this._panels);
    active(this._media);
    const link = this._links[index];
    const scroller = link?.closest('.bz-inside__tabs');
    if (!scroller) return;
    const place = () => {
      const box = link.getBoundingClientRect();
      const view = scroller.getBoundingClientRect();
      const delta = box.left < view.left + 8 ? box.left - view.left - 8 : box.right > view.right - 8 ? box.right - view.right + 8 : 0;
      if (delta) scroller.scrollTo({ left: Math.max(0, scroller.scrollLeft + delta), behavior: 'smooth' });
    };
    place();
    clearTimeout(this._scrollTimer);
    this._scrollTimer = setTimeout(place, 320);
  }
}
customElements.define('wb-tab-view', WbTabView);

// Quick view
class WbQuickView extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => this.wbOpenQuickView(e));
  }

  async wbOpenQuickView(e) {
    const button = e.target.closest('button');
    if (!button) return;

    const loader = button.querySelector('.loader_state');
    button.classList.add('loading');
    loader?.classList.remove('hidden');
    button.setAttribute('disabled', 'true');

    try {
      const base = button.dataset.url?.split('?')[0];
      const template = button.dataset.template || 'quick-view';
      const variant = button.dataset.variantid ? `&variant=${button.dataset.variantid}` : '';
      const response = await fetch(`${base}?view=${template}${variant}`);
      if (!response.ok) throw new Error(`Failed to load: ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const contentEl = doc.querySelector('[data-html="content"]');
      if (!contentEl) throw new Error('Quick View content not found');

      let modal = document.querySelector('.js-quick_view');
      if (!modal) {
        modal = document.createElement('wb-modal');
        modal.classList.add('js-quick_view');
        document.body.appendChild(modal);
      }
      modal.innerHTML = contentEl.innerHTML;
      contentEl.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
        const href = link.getAttribute('href');
        if (!href || document.querySelector(`link[href="${href}"]`)) return;
        const next = document.createElement('link');
        next.rel = 'stylesheet';
        next.href = href;
        document.head.appendChild(next);
      });
      const dialogHost = modal.querySelector('wb-modal') || modal;
      dialogHost._returnTo = button;
      window.BzA11y?.trapFocus(dialogHost, { initial: false, returnTo: button });
      const sub = modal.querySelector('bz-subscription');
      if (sub && !customElements.get('bz-subscription') && sub.dataset.js) {
        const script = document.createElement('script');
        script.src = sub.dataset.js;
        script.defer = true;
        document.head.appendChild(script);
      }

      const shell = document.querySelector('wb-modal');
      if (shell) setTimeout(() => shell.classList.add('quick_popup'), 300);

      document.body.classList.add('overflow-hidden', 'modal_view');
      if (typeof window.ProductForm !== 'undefined') {
        modal.querySelectorAll('product-form').forEach((el) => new window.ProductForm(el));
      }
    } catch (error) {
      console.error('Quick View Error:', error);
      alert('Something went wrong loading the quick view. Please try again.');
    } finally {
      button.classList.remove('loading');
      loader?.classList.add('hidden');
      button.removeAttribute('disabled');
    }
  }
}
customElements.define('wb-quick-view', WbQuickView);

// Quick view modal shell
class WbModal extends HTMLElement {
  constructor() {
    super();
    this.closeEl = this.querySelector('.modal__close button');
    this.modalContent = this.querySelector('.wb_quick_content');
    this.previousActiveElement = document.activeElement;
    this.#watchDrawerLock();
  }

  connectedCallback() {
    setTimeout(() => this.#focusStart(), 50);
    this.closeEl?.addEventListener('click', () => this.close());
    this.cartBtnElement?.addEventListener('click', () => this.close());

    this._onEscape = (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) this.close();
    };
    document.addEventListener('keydown', this._onEscape);

    this.addEventListener('click', (event) => {
      const inside = this.modalContent?.contains(event.target);
      const onClose = event.target.closest('.modal__close button');
      if (!inside || onClose) this.close();
    });
  }

  #watchDrawerLock() {
    new MutationObserver((list) => {
      if (list.some((m) => m.attributeName === 'class' && document.body.classList.contains('overflow-hidden-drawer'))) {
        this.close();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onEscape);
  }

  #focusStart() {
    const dialog = this.querySelector('.wb_quick_content');
    if (dialog) {
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      const title = dialog.querySelector('h1, h2, .product__title');
      if (title?.textContent.trim() && !dialog.hasAttribute('aria-label')) {
        dialog.setAttribute('aria-label', title.textContent.trim().replace(/\s+/g, ' '));
      }
    }
    const first = window.BzA11y ? window.BzA11y.getFocusable(this)[0] : this.querySelector(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    first?.focus({ preventScroll: true });
  }

  close() {
    if (this._closing) return;
    this._closing = true;
    this.classList.remove('quick_popup');
    window.BzA11y?.releaseFocus(this, { restore: false });
    setTimeout(() => {
      const returnTo = this._returnTo || this.previousActiveElement;
      this.remove();
      document.body.classList.remove('overflow-hidden', 'modal_view');
      returnTo?.focus?.({ preventScroll: true });
    }, 300);
  }

  get cartBtnElement() {
    return this.querySelector('.product-form__submit');
  }
}
customElements.define('wb-modal', WbModal);

// Variant select (wb)
class WbVariantSelects extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (event) => {
      const input = this.#resolveInput(event.target);
      this.#syncSelectionMeta(event);
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target: input,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  #syncSelectionMeta({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const prevSelected = Array.from(target.options).find((option) => option.getAttribute('selected'));
      prevSelected?.removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const activeOption = target.selectedOptions[0];
      const swatchValue = activeOption.dataset.optionSwatchValue;
      const swatchPreview = target
        .closest('.bz_product_input')
        ?.querySelector('[data-selected-value] > .swatch');
      if (!swatchPreview) return;

      if (swatchValue) {
        swatchPreview.style.setProperty('--swatch--background', swatchValue);
        swatchPreview.classList.remove('swatch--unavailable');
      } else {
        swatchPreview.style.setProperty('--swatch--background', 'unset');
        swatchPreview.classList.add('swatch--unavailable');
      }

      swatchPreview.style.setProperty(
        '--swatch-focal-point',
        activeOption.dataset.optionSwatchFocalPoint || 'unset'
      );
      return;
    }

    if (tagName === 'INPUT' && target.type === 'radio') {
      const fieldset = target.closest('fieldset');
      const selectedLabel = fieldset?.querySelector('[data-selected-value]');
      if (selectedLabel) selectedLabel.innerHTML = value;

      const selectedOptionLabel = fieldset?.querySelector('[data-selected-option-label]');
      if (selectedOptionLabel && window.variantStrings?.yourOption) {
        const optionName = selectedOptionLabel.dataset.optionName || '';
        selectedOptionLabel.innerHTML = window.variantStrings.yourOption
          .replace('[name]', optionName)
          .replace('[value]', value);
      }
    }
  }

  #resolveInput(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll('select option[selected], fieldset input:checked')
    ).map(({ dataset }) => dataset.optionValueId);
  }
}
customElements.define('wb-variant-select', WbVariantSelects);

// Color swatch hover / navigate (wb)
class WbColorSwatch extends WbVariantSelects {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const label = event.target.closest('label');
      if (!label || !this.contains(label)) return;
      this.#onLabelNavigate(event, label);
    });
    this.addEventListener('mouseover', (event) => {
      const label = event.target.closest('label');
      if (!label || !this.contains(label)) return;
      if (event.relatedTarget && label.contains(event.relatedTarget)) return;
      this.#onHoverPreview(label);
    });
  }

  #onLabelNavigate(event, label) {
    const href = this.#hrefForLabel(label);
    if (!href) return;
    event.preventDefault();
    window.location.href = href;
  }

  #hrefForLabel(label) {
    if (label.dataset.href) return label.dataset.href;

    const inputId = label.htmlFor || label.getAttribute('for');
    const input = inputId ? this.querySelector(`#${CSS.escape(inputId)}`) : null;
    const optionId = input?.dataset.optionValueId;
    const productUrl = input?.dataset.productUrl || this.dataset.url;
    if (!productUrl) return '';

    try {
      const url = new URL(productUrl, window.location.origin);
      if (optionId) url.searchParams.set('option_values', optionId);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return productUrl;
    }
  }

  #onHoverPreview(label) {
    const inputId = label.htmlFor || label.getAttribute('for');
    if (!inputId) return;
    const input = this.querySelector(`#${CSS.escape(inputId)}`);
    if (input && !input.checked) input.click();
  }
}
customElements.define('wb-color-swatch', WbColorSwatch);

// sticky cart height
const stickyElement = document.querySelector('.sticky_pro_page');
if (stickyElement) {
  const stickyHeight = stickyElement.offsetHeight;
  document.documentElement.style.setProperty('--sticky-pro-page-height', `${stickyHeight}px`);
}



// Account sheet locks the page; its own dialog still scrolls.
(() => {
  const onAccount = (e) => {
    if (e.target?.tagName !== 'SHOPIFY-ACCOUNT') return;
    document.body.classList.toggle('account-open', e.type === 'open');
  };
  addEventListener('open', onAccount, true);
  addEventListener('close', onAccount, true);
})();

// Smooth scrolling
(() => {
  if (!window.themeSettings?.enableSmoothScroll) return;

  const root = document.documentElement;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const setNative = () => {
    root.style.scrollBehavior = reduceMotion.matches ? '' : 'smooth';
  };
  setNative();
  reduceMotion.addEventListener('change', setNative);

  // Touch / reduced-motion: keep native scrolling only.
  if (reduceMotion.matches || matchMedia('(hover: none)').matches) return;

  const EASE = 0.12;
  let goal = scrollY;
  let view = scrollY;
  let raf = 0;

  const blocksPageScroll = (node, dy) => {
    for (let el = node; el && el !== root && el !== document.body; el = el.parentElement) {
      const { overflowY } = getComputedStyle(el);
      if (overflowY !== 'auto' && overflowY !== 'scroll') continue;
      if (el.scrollHeight <= el.clientHeight) continue;
      const top = el.scrollTop <= 0;
      const bottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
      if (!((dy < 0 && top) || (dy > 0 && bottom))) return true;
    }
    return false;
  };

  const tick = () => {
    if (document.body.classList.contains('overflow-hidden') || document.body.classList.contains('account-open')) {
      raf = 0;
      goal = view = scrollY;
      setNative();
      return;
    }
    view += (goal - view) * EASE;
    if (Math.abs(goal - view) < 0.5) {
      view = goal;
      scrollTo(0, view);
      raf = 0;
      setNative();
      return;
    }
    scrollTo(0, view);
    raf = requestAnimationFrame(tick);
  };

  addEventListener('wheel', (e) => {
    if (e.ctrlKey || blocksPageScroll(e.target, e.deltaY) || document.body.classList.contains('o-hidden') || document.body.classList.contains('overflow-hidden') || document.body.classList.contains('account-open')) return;
    e.preventDefault();

    if (!raf) {
      view = goal = scrollY;
      root.style.scrollBehavior = 'auto';
      raf = requestAnimationFrame(tick);
    }

    const max = Math.max(0, root.scrollHeight - innerHeight);
    goal = Math.min(max, Math.max(0, goal + e.deltaY));
  }, { passive: false });
})();